<template>
    <div id="app" data-app="true">

  <router-view></router-view>
  </div>
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/

/* Global Theme Improvements */
:root {
  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --primary-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
  --secondary-gradient: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

/* Enhanced Header Styling */
.header {
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Enhanced Sidebar Styling */
.aside {
  backdrop-filter: blur(10px);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

/* Improved Button Styling */
.btn-primary {
  background: var(--primary-gradient) !important;
  border: none !important;
  box-shadow: var(--primary-shadow) !important;
  transition: all 0.3s ease !important;
}

.btn-primary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4) !important;
}

/* Enhanced Card Styling */
.card {
  border-radius: 12px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.card:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12) !important;
}

/* Improved Form Controls */
.form-control:focus {
  border-color: #667eea !important;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25) !important;
}

/* Enhanced Navigation */
.nav-link {
  transition: all 0.3s ease !important;
}

.nav-link:hover {
  transform: translateX(5px) !important;
}

/* Improved Loading States */
.spinner-border {
  color: #667eea !important;
}

/* Enhanced Modal Styling */
.modal-content {
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
}

/* Improved Table Styling */
.table {
  border-radius: 12px !important;
  overflow: hidden !important;
}

.table thead th {
  background: var(--primary-gradient) !important;
  color: white !important;
  border: none !important;
  font-weight: 600 !important;
}

/* Enhanced Pagination */
.page-link {
  border-radius: 8px !important;
  margin: 0 2px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.page-link:hover {
  background: var(--primary-gradient) !important;
  color: white !important;
  transform: translateY(-1px) !important;
}

.page-item.active .page-link {
  background: var(--primary-gradient) !important;
  border-color: #667eea !important;
}
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { UPDATE_AUTH } from "@/core/services/store/auth.module";

export default {
  name: "GetMeFood",
  mounted() {
    /* Update user state from session storage*/

    // let userAuth = sessionStorage.getItem('USER_STATE');
    // if (userAuth) {

    //   this.$store.dispatch(UPDATE_AUTH);
    // }

    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  }
};
</script>
